import { NetFront, NetUserWealth } from "@/constants/netEvent.ts";
import { reqPost } from "@/service/clientRequest.ts";
import {
  GetRealtimeFiatExchangesCurrRateReq,
  GetRealtimeFiatExchangesCurrRateResp,
} from "@/types/swagger/appserver";
import {
  GetGameRecordByShareHashReq,
  GetGameRecordByShareHashResp,
} from "@/types/swagger/appserver.ts";
import {
  BindPutInfoReq,
  GetPutTypesV2Req,
  GetPutTypesV2Rsp,
  GetPutTypesV4Req,
  GetPutTypesV4Rsp,
  GetUserPayChannelReq,
  GetUserPayChannelRsp,
  GetWithdrawChannelV3Req,
  GetWithdrawChannelV3Rsp,
  GetWithdrawChannelV4Req,
  GetWithdrawChannelV4Rsp,
  PayPageOpenStatusReq,
  RemovePutInfoReq,
  UserApplyPayV2Req,
  UserApplyPayV2Rsp,
  UserApplyWithdrawV3Req,
  UserApplyWithdrawV3Rsp,
} from "@/types/swagger/userwealth.ts";

export async function GetPutTypesV2(data: GetPutTypesV2Req) {
  return await reqPost<GetPutTypesV2Req, GetPutTypesV2Rsp>(
    data,
    NetUserWealth.mod,
    NetUserWealth.GetPutTypesV2,
    true,
  );
}

export async function GetPutTypesV4(data: GetPutTypesV4Req) {
  return await reqPost<GetPutTypesV4Req, GetPutTypesV4Rsp>(
    data,
    NetUserWealth.mod,
    NetUserWealth.GetPutTypesV4,
    true,
  );
}

export async function RemovePutInfo(data: RemovePutInfoReq) {
  return await reqPost<RemovePutInfoReq, null>(
    data,
    NetUserWealth.mod,
    NetUserWealth.RemovePutInfo,
    true,
  );
}

export async function GetUserPayChannelV2(data: GetUserPayChannelReq) {
  return await reqPost<GetUserPayChannelReq, GetUserPayChannelRsp>(
    data,
    NetUserWealth.mod,
    NetUserWealth.GetUserPayChannelV2,
    true,
  );
}

export async function UserApplyPayV2(
  data: UserApplyPayV2Req,
  shwoloading: boolean,
) {
  return await reqPost<UserApplyPayV2Req, UserApplyPayV2Rsp>(
    data,
    NetUserWealth.mod,
    NetUserWealth.UserApplyPayV2,
    true,
  );
}

export async function PayPageOpenStatus(data: PayPageOpenStatusReq) {
  return reqPost<PayPageOpenStatusReq, {}>(
    data,
    NetUserWealth.mod,
    NetUserWealth.PayPageOpenStatus,
    true,
  );
}

export async function GetUserPayUrlV2(data: { order_no: string }) {
  return reqPost<{ order_no: string }, UserApplyPayV2Rsp>(
    data,
    NetUserWealth.mod,
    NetUserWealth.GetUserPayUrlV2,
    true,
  );
}

export async function GetWithdrawChannelV3(data: GetWithdrawChannelV3Req) {
  return await reqPost<GetWithdrawChannelV3Req, GetWithdrawChannelV3Rsp>(
    data,
    NetUserWealth.mod,
    NetUserWealth.GetWithdrawChannelV3,
    true,
  );
}

export async function GetWithdrawChannelV4(data: GetWithdrawChannelV4Req) {
  return await reqPost<GetWithdrawChannelV4Req, GetWithdrawChannelV4Rsp>(
    data,
    NetUserWealth.mod,
    NetUserWealth.GetWithdrawChannelV4,
    true,
  );
}

export async function UserApplyWithdrawV3(data: UserApplyWithdrawV3Req) {
  return await reqPost<UserApplyWithdrawV3Req, UserApplyWithdrawV3Rsp>(
    data,
    NetUserWealth.mod,
    NetUserWealth.UserApplyWithdrawV3,
    true,
  );
}

export async function BindPutInfo(data: BindPutInfoReq) {
  return await reqPost<BindPutInfoReq, {}>(
    data,
    NetUserWealth.mod,
    NetUserWealth.BindPutInfo,
    true,
  );
}

export async function GetRealtimeFiatExchangeCurrRates(
  data: GetRealtimeFiatExchangesCurrRateReq,
) {
  return await reqPost<
    GetRealtimeFiatExchangesCurrRateReq,
    GetRealtimeFiatExchangesCurrRateResp
  >(data, NetFront.mod, NetFront.GetRealtimeFiatExchangeCurrRates);
}

export async function GetGameRecordByShareHash(
  data: GetGameRecordByShareHashReq,
) {
  return await reqPost<
    GetGameRecordByShareHashReq,
    GetGameRecordByShareHashResp
  >(data, NetFront.mod, NetFront.GetGameRecordByShareHash);
}
